module.exports = __webpack_public_path__ + "img/left-indent-01.4bb634fd.svg";